import { createFileRoute, Outlet } from '@tanstack/react-router';

import { useIsInterviewRoute } from './-hooks/use-is-interview-route';

export const Route = createFileRoute('/participants')({
  component: ParticipantsLayout,
});

function ParticipantsLayout() {
  const isInterview = useIsInterviewRoute();

  if (isInterview) {
    return (
      <div className="h-dvh overflow-y-auto">
        <Outlet />
      </div>
    );
  }

  return <Outlet />;
}
